import { useEffect, useState } from "react";
import { adminListBookings, adminUpdateBooking } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const STATUSES = ["new", "contacted", "confirmed", "completed", "cancelled"];

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = () => { setLoading(true); adminListBookings().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);

  const changeStatus = async (booking_id, status) => {
    await adminUpdateBooking(booking_id, status);
    setItems((prev) => prev.map((b) => (b.booking_id === booking_id ? { ...b, status } : b)));
    toast("Status updated", { description: status });
  };

  const shown = filter === "all" ? items : items.filter((b) => b.status === filter);

  return (
    <div>
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-serif-latin text-3xl text-ink">Bookings & Requests</h1>
          <p className="mt-1 text-sm text-ink-3">{items.length} total</p>
        </div>
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-40 rounded-none border-line bg-surface"><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-none border-line bg-surface">
            <SelectItem value="all">All statuses</SelectItem>
            {STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {loading ? <p className="py-16 text-center text-ink-3">…</p> : shown.length === 0 ? (
        <p className="py-16 text-center text-ink-3">No bookings.</p>
      ) : (
        <div className="space-y-4">
          {shown.map((b) => (
            <div key={b.booking_id} data-testid={`admin-booking-${b.booking_id}`} className="border border-line bg-surface p-5">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <p className="font-serif-latin text-lg text-ink">{b.service_name || b.booking_type}</p>
                  <p className="text-sm capitalize text-ink-3">{b.booking_type} · {b.name} · {b.phone}</p>
                  {b.email && <p className="text-xs text-ink-3">{b.email}</p>}
                  <p className="mt-1 text-xs text-ink-3">
                    {b.preferred_date && `Preferred: ${b.preferred_date} · `}
                    {b.birth_date && `Birth: ${b.birth_date} ${b.birth_time || ""} ${b.birth_place || ""} · `}
                    {b.city}
                  </p>
                  {b.message && <p className="mt-2 text-sm italic text-ink-2">"{b.message}"</p>}
                  <p className="mt-2 font-mono text-xs text-ink-3">{b.booking_id}</p>
                </div>
                <Select value={b.status} onValueChange={(v) => changeStatus(b.booking_id, v)}>
                  <SelectTrigger data-testid={`booking-status-${b.booking_id}`} className="w-36 rounded-none border-line bg-parchment capitalize"><SelectValue /></SelectTrigger>
                  <SelectContent className="rounded-none border-line bg-surface">
                    {STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
